import { supabase } from '@/lib/supabase';
import { Testimonial } from '@/types/types';

export const testimonialService = {
  getAllTestimonials: async (): Promise<Testimonial[]> => {
    try {
      const { data, error } = await supabase
        .from('testimonials')
        .select('*')
        .order('id');

      if (error) throw error;
      return data as Testimonial[];
    } catch (error) {
      console.error('Error fetching testimonials:', error);
      throw error;
    }
  }
};
